import type { QueryClient } from "@tanstack/react-query";
import { CALCULATION_CYCLE_STALE_TIME_MS } from "@/features/tuition/constants";
import {
  fetchCurrentCalculationCycle,
  getCurrentCalculationCycleQueryKey,
} from "@/features/tuition/utils/fetch-calculation-cycles";
import { resolveEffectiveTenantNumber } from "@/lib/utils/env/effective-tenant";

export async function prefetchCalculationCycleCurrent(
  queryClient: QueryClient,
  accessToken: string,
  tenantId: number = resolveEffectiveTenantNumber(),
) {
  await queryClient.prefetchQuery({
    queryKey: getCurrentCalculationCycleQueryKey(),
    queryFn: () => fetchCurrentCalculationCycle(accessToken, tenantId),
    staleTime: CALCULATION_CYCLE_STALE_TIME_MS,
  });

  return queryClient;
}
